(async () => {
    const { Core } = await importModule('Core');
    const { Plyr } = await importModule('Plyr');

    customElements.define('video-player', class extends Core {

        elements = {
            embeddedPlayer: '[data-player]',
            HTML5Player: 'video',
            closeBtn: '.video-close'
        }

        render() {
            // Init Plyr
            this.player = new Plyr(this.$player, {
                ratio: '16:9'
            });

            // Pause when close button clicked
            if (this.$closeBtn) {
                this.$closeBtn.addEventListener('click', () => {
                    this.player.pause();
                });
            }

            // ✅ Pause when mouse leaves video area
            this.addEventListener('mouseleave', () => {
                if (this.player) this.player.pause();
            });
        }

        get $player() {
            return this.$embeddedPlayer || this.$HTML5Player
        }
    })
})();
